
import api from '@/plugins/api'
import { mapGetters } from 'vuex'
import { openUrl } from '~/plugins/util'
export default {
    props: {
        text: { type: String, default: '' },
        width: { type: String, default: '160px' },
        height: { type: String, default: '44px' },
        radius: { type: String, default: '6px' },
        isList: { type: Boolean, default: true }, // 是否在列表中
        info: { type: Object, default: () => {} }  // isBuy:是否购买记录中的
    },
    data() {
        return {
        };
    },
    computed: {
        ...mapGetters('user', ['token'])
    },
    created() {
    },
    methods: {
        tapBtn() {
            if(!this.token) return this.$store.commit('setIsLogin', true);

            // 购买记录列表操作
            if(this.info && this.info.isBuy) return this.$emit('buyBtn');

            // 免费
            if(!this.info || !parseFloat(this.info.price)) return this.Download();
            
            if(this.isList) return this.$emit('toDeatil');

            // 支付
            openUrl(this.$router, {
                path: '/pay',
                query: { id: this.info.id }
            })
        },

        // 下载
        Download() {
            if(!this.info || !this.info.id) return;

            let method = '';
            if(this.info.from == 'pic') method = 'downloadImage';
            if(!method) return;

            this.$axios.$post(api[method], { id: this.info.id })
            .then(data => {
                if(!data || !data.info || !data.info.downurl) return this.$message.error('啊哦，网络走丢了~ 请稍后再试！')
                location.href = data.info.downurl;
            })
            .catch(err => {
                this.$message.error(err || '啊哦~网络在开小差，请稍后再试！');
            });
        }

    }
}
